export default __webpack_public_path__ + "static/media/sunny.9b7378c7.jpg";